import { createFileRoute, redirect } from '@tanstack/react-router';
import { isXeroEnabled } from '@/lib/feature-flags';
import { FinanceGuard } from '@/components/finance/FinanceGuard';
import { FinanceBoard } from '@/components/finance/FinanceBoard';

/**
 * /finance/dashboards — the finance boards area (F-013/F-125). The board IS the screen: this renders
 * the default "My metrics" board; the §P sub-selector under the nav switches boards, and each named
 * board lives at /finance/dashboards/<id>. Ported from the F-125 prototype, wired to real Xero data.
 */
export const Route = createFileRoute('/finance/dashboards')({
  beforeLoad: () => {
    if (!isXeroEnabled()) {
      throw redirect({ to: '/finance', replace: true });
    }
  },
  component: () => (
    <FinanceGuard>
      <FinanceBoard boardId="all" />
    </FinanceGuard>
  ),
});
